export const properSemantic = (minutesAmount) => {
  let properWord = ""
  if(minutesAmount < 1){
    properWord = "<1 minuta"
    return properWord
  } else if(minutesAmount < 11){
    if(minutesAmount === 1){
      properWord = "1 minuta"
    return properWord
    }else if(minutesAmount % 10 >=2 && minutesAmount % 10 <=4){
      properWord = `${minutesAmount} minuty`
    return properWord
    }else{
      properWord = `${minutesAmount} minut`
    return properWord
    }

  }else if(minutesAmount >= 11 && minutesAmount <= 20 ){
    properWord = `${minutesAmount} minut`
    return properWord
  }else{
    if(minutesAmount % 10 >=2 && minutesAmount % 10 <=4){
      properWord = `${minutesAmount} minuty`
    return properWord
    }else{
      properWord = `${minutesAmount} minut`
    return properWord
    }
  }

}
